export const SHOW_NOTIFICATION = 'notifier/SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'notifier/HIDE_NOTIFICATION';
export const UPDATE_LAST_UPDATED_TIMESTAMP = 'notifier/UPDATE_LAST_UPDATED_TIMESTAMP';